// extracted by mini-css-extract-plugin
export default {"profile_div":"Register_profile_div__waEcf"};